// extracted by mini-css-extract-plugin
export default {"appBanner":"AppBanner_appBanner__R8cH-","appIcon":"AppBanner_appIcon__oHMS4","open":"AppBanner_open__iOFM6","emojlIcon":"AppBanner_emojlIcon__JO7iy"};